import React from "react";
import bindAll from 'lodash.bindall';
import styles from './operation-button.css';
import Button from 'antd/lib/button'
import {connect} from 'react-redux';
import { getEnv, Environment } from "../../../lib/xes/xes";
import { sessionStore } from '../../../lib/xes/local-store';

let toggleExitDisabled
class ExitButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      maximize: false,
      disabled: false
    }
    toggleExitDisabled = (disabled) => {
      this.setState({
        disabled
      })
    }
    bindAll(this, [
      'handleExit'
    ])
    this.env = getEnv()
    this.isSupportEnv = [Environment.BAIZE].includes(this.env) ? true : false
  }
  componentDidUpdate(preProps) {
  }
  handleExit() {
    const answer_url = sessionStore.get('answer_url')

    sessionStore.store('userAnswerData', '')
    sessionStore.store('isFill', '1')
    sessionStore.store('isFreshAnswer', '0')
    sessionStore.store('isFreshAnalysis', '0')
    window.location.href = answer_url
  }
  render() {
    if(!this.isSupportEnv) return null
    return (
      <div>
        <Button onClick={this.handleExit} className={styles.operationButton} loading={this.state.loading}
            style={{
                width: '5rem',
                /* marginRight: '1rem', */
                color: '#4A82F7',
                borderRadius: '0.25rem',
                outline: 'none',
                border: 'none',
                fontSize: '0.88rem',
                fontWeight: '600'
            }}
            disabled={this.state.disabled}
        >{
          '退出'
        }</Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  state
})
const mapDispatchToProps = (dispatch) => ({
  dispatch
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExitButton)

export {
  toggleExitDisabled
}